import { render, staticRenderFns } from "./PageSoilSamples.vue?vue&type=template&id=67285be5&scoped=true&"
import script from "./PageSoilSamples.vue?vue&type=script&lang=js&"
export * from "./PageSoilSamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67285be5",
  null
  
)

export default component.exports